<div class="text-center">
  <!-- <i class="pi pi-sign-out text-danger mb-3" style="font-size: 3rem"></i> -->
  <h5 class="fw-bold">¿Quieres cerrar sesión?</h5>
  <p class="text-muted">Perderás cualquier cambio no guardado.</p>

  <div class="d-flex justify-content-center gap-2 mt-4">
    <p-button
      label="Cancelar"
      severity="secondary"
      [text]="true"
      (onClick)="close(false)"
      class="flex-grow-1"
    />
    <p-button label="Cerrar sesión" severity="danger" (onClick)="close(true)" class="flex-grow-1" />
  </div>
</div>
